import React from "react";
import FlipClock from "../../flipClock";

/**
 * Timer overlay (bottom-right) — reference FlipClock markup
 * (div.casino-timer.clock.flip-clock-wrapper), positioned by index.css.
 */
export default function VideoBoxTimer({ timerValue }) {
  return <FlipClock initialTime={timerValue || 0} />;
}
